/**
 * This is part of the new Rider Funnel experience
 */
SC.login = (function () {
  const initializeLogin = function () {
    const $loginForm = $('form.login__form');
    const $loginButton = $('#handle-login');
    const $loginForgotPasswordButton = $('#nrf-forgot-password-button');
    const $loginNewToSoulButton = $('#nrf-create-account-button');
    const $formError = $('.global-form__error');
    const $inputs = $('.global__input');
    const $analyticsLocation = $('#analytics_location');
    const $modalPasswordReset = $('#modal-password_reset_notification');
    const $modalCloseBtn = $('#modal-password_reset_notification .button__primary');
    const $modalCloseX = $('#modal-password_reset_notification .close');

    const analyticsLocationVal = $analyticsLocation.val();
    const location = (analyticsLocationVal && analyticsLocationVal.length > 0) ? analyticsLocationVal : 'New Rider';

    let eventData = {};

    /**
     * loginRider send the request to login the rider
     * @returns {void}
     */
    const loginRider = function () {
      $loginForm.clearFormErrors();
      $loginForm.updateCsrfToken();
      $formError.text('');
      let params = new URL(document.location.toString()).searchParams;
      let providerId = params.get('pid');
      $loginForm.ajaxSubmit({
        url: '/login/',
        dataType: 'json',
        data: {providerId: providerId},
        success: function (data) {
          $loginForm.updateCsrfToken();

          if (data.success) {
            /**
             * mparticle user identity setup
             */
            SC.analytics.mp.userEvent('remove');
            let userEventPromise = SC.analytics.mp.userEvent('setup', data.rider.id.toString());
            userEventPromise.then(function () {
              // Set mp events only when the response is correct.
              SC.analytics.mp.userEvent('attribute', data.rider.first_name, 'first_name');

              if (data.rider.do_not_sell_approved && data.rider.do_not_sell_approved === true) {
                SC.analytics.mp.setupConsent(Date.now(), '', location);
              }

              /**
               * mParticle sendEvent - Click Log In CTA- Success
               * Sends mParticle event with a label for GA Event.
               */
              eventData = {
                'Response': 'Success',
                'Location': location
              };
              SC.analytics.mp.sendEvent('Click Log In CTA', 'navigation', eventData, location);
            });

            userEventPromise.always(function () {
              getPostLoginRedirect(data?.redirect);
            });
          }
        },
        error: function (jqXHR, status, errorThrown) {
          $loginForm.updateCsrfToken();
          if (window.grecaptcha && typeof window.grecaptcha.reset === 'function') {
            window.grecaptcha.reset();
          }

          if (jqXHR && jqXHR.status === 401) {
            let data = jqXHR && jqXHR.responseJSON;
            if (data.tooManyAttemps) {
              $loginForm.find('.recaptcha-message').addClass('too-many-attempts');
            }

            if (jqXHR.responseJSON.reason && jqXHR.responseJSON.reason === 'password_strength') {
              $modalPasswordReset.show();
            } else {
              /**
               * mParticle sendEvent - Click Log In CTA - Invalid
               * Sends mParticle event with a label for GA Event.
               */
              eventData = {
                'Response': 'Invalid email or password',
                'Location': location
              };
              SC.analytics.mp.sendEvent('Click Log In CTA', 'navigation', eventData, location);

              $loginForm.fieldErrors(data.fieldErrors);
              if (!data.fieldErrors || data.fieldErrors.length === 0) {
                $formError.text(data.message || genericErrorMessage);
              }

              $loginButton.prop('disabled', false);
            }

            return;
          }

          eventData = {
            'Response': 'Server Error - status: ' + status + ', error: ' + errorThrown,
            'Location': location
          };
          SC.analytics.mp.sendEvent('Click Log In CTA', 'navigation', eventData, location);
          $formError.text(genericErrorMessage);
          $loginButton.prop('disabled', false);
        }
      });
    };

    /**
     * Function to handle redirect after login.
     * It attempts to find a login_redirect query parameter to redirect to;
     * otherwise, gets the redirect url from the backend with an AJAX request,
     * which defaults to the homepage on error.
     * @param {string} responseRedirect - The redirect URL from the response
     *
     * @returns {void}
     */
    const getPostLoginRedirect = function getPostLoginRedirect(responseRedirect) {
      let redirectUrlParam = 'login_redirect';
      let urlParamRegex = new RegExp('[\\?&]' + redirectUrlParam + '=([^&#]*)');
      let regexResults = urlParamRegex.exec(window.location.search);
      let redirectUrl = regexResults === null ? '' : decodeURIComponent(regexResults[1].replace(/\+/g, ' '));

      if (redirectUrl) {
        window.location.replace(redirectUrl);
        return;
      }

      if (responseRedirect) {
        window.location.replace(responseRedirect);
        return;
      }

      window.location.replace('/');
    };

    // Handles the `Login` logic to login the user in the web
    $loginButton.on('click', function () {
      $loginButton.prop('disabled', true);
      loginRider();
    });

    $loginForgotPasswordButton.on('click', function () {
      eventData = {
        'Location': location
      };
      SC.analytics.mp.sendEvent('Click Forgot Password', 'navigation', eventData, location);
    });

    $loginNewToSoulButton.on('click', function () {
      eventData = {
        'Location': location,
        'Context': 'Log In'
      };
      SC.analytics.mp.sendEvent('Click to Sign Up', 'navigation', eventData, location);
    });

    $inputs.on('keydown', $loginForm, function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        $loginButton.trigger('click');
      }
    });

    $modalCloseBtn.click(function () {
      $modalPasswordReset.hide();
    });

    $modalCloseX.click(function () {
      $modalPasswordReset.hide();
    });
  };
  const api = {};

  const init = function () {
    if (!$('body').hasClass('new_rider_login')) {
      return;
    }

    initializeLogin();
  };

  init();

  return api;
})();
